import { render } from "./PreviewInvoice.vue?vue&type=template&id=c50df96a&scoped=true"
import script from "./PreviewInvoice.vue?vue&type=script&lang=js"
export * from "./PreviewInvoice.vue?vue&type=script&lang=js"

import "./PreviewInvoice.vue?vue&type=style&index=0&id=c50df96a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50df96a"]])

export default __exports__